import { useContext } from 'react';
import { useProduct, useCollectionDetail, useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  useCollectionDetailDeprecated,
  useProductDeprecated
} from '@thd-nucleus/data-sources/react/dataModel/migration';

export const useSizeGuide = ({
  isCollection, isSuperSku, itemId, superSkuSizeAndFitDetail, itemSizeAndFitDetail, storeIdFromMock
}) => {
  const {
    store,
    clientStore
  } = useContext(ExperienceContext) || {};

  const { storeId } = clientStore || store || {};

  let data;
  let loading;
  let error;

  if (isCollection) {
    const {
      data: collectionDetail,
      loading: collectionLoading,
      error: collectionError
    } = useCollectionDetailDeprecated({
      collectionId: itemId,
      storeId: storeIdFromMock || storeId,
      ssr: false,
      productDomains: ['media']
    });
    // useDataModel('collection', {
    //   ssr: false,
    //   variables: {
    //     collectionId: itemId,
    //     storeId: storeIdFromMock || storeId
    //   }
    // });

    data = collectionDetail?.collection?.sizeAndFitDetail;
    loading = collectionLoading;
    error = collectionError;
  } else if (isSuperSku) {
    data = superSkuSizeAndFitDetail;
    loading = false;
    error = false;
  } else {
    const hasItemSizeAndFitDetail = Object.keys(itemSizeAndFitDetail)?.length;

    if (hasItemSizeAndFitDetail) {
      data = hasItemSizeAndFitDetail;
      loading = false;
      error = false;
    } else {
      const {
        data: productData,
        loading: productLoading,
        error: productError
      } = useProductDeprecated({
        itemId,
        storeId: storeIdFromMock || storeId,
        domains: ['sizeAndFitDetail'],
        ssr: false
      });
      // useDataModel('product', {
      //   variables: {
      //     itemId,
      //     dataSource: 'catalog'
      //   }
      // });
      data = productData?.product?.sizeAndFitDetail;
      loading = productLoading;
      error = productError;
    }
  }

  return { data, loading, error };
};
